// @ts-nocheck
import {
    blueLinks,
    cobalBlue500,
    crystal50,
    crystal500,
    robotoRegular,
    scarpaGray100,
    scarpaGray25,
    scarpaGray400,
    scarpaGray50,
    scarpaGray500,
    scarpaGray800,
    spanishViridian25,
    spanishViridian500,
    white,
} from '@habitech/shared';
import styled from 'styled-components';

interface StatusWrapperProps {
    ref?: React.MutableRefObject | null;
    isDisabled?: boolean;
}

export const Container = styled.div`
    position: relative;
    display: flex;
`;
export const Wrapper = styled.div<StatusWrapperProps>`
    font-family: ${robotoRegular};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px;
    width: fit-content;
    height: fit-content;
    padding: 2px 6px;
    border-radius: 4px;
    text-transform: lowercase;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    cursor: ${({ isDisabled }) => (isDisabled ? 'unset' : 'pointer')};

    .label {
        margin: 0;
        &:first-letter {
            text-transform: uppercase;
        }

        &.blue {
            color: ${white};
        }

        &.grey,
        &.ocean {
            color: ${scarpaGray800};
        }
    }

    .icon {
        color: ${scarpaGray500};

        &.blue {
            color: ${white};
        }
    }

    .icon-rotate {
        transition: transform 0.45s ease;
    }

    .icon-rotate.open {
        transform: rotate(180deg);
    }

    @media ${({ theme }) => theme.screenSizes.tablet} {
        line-height: 22px;
    }
    @media ${({ theme }) => theme.screenSizes.laptop} {
        line-height: 18px;
    }
    &.blue {
        background: ${blueLinks};
        color: ${white};
        border: 1px solid ${blueLinks};
        &:hover {
            border: 1px solid ${cobalBlue500};
        }
    }

    &.grey {
        background: #d3d3d4;
        color: ${scarpaGray800};
        border: 1px solid ${scarpaGray25};

        &-light {
            background: ${scarpaGray100};
        }

        &:hover {
            border: 1px solid ${scarpaGray100};
        }
    }

    &.ocean {
        background: ${crystal50};
        color: ${scarpaGray800};
        border: 1px solid ${crystal50};
        &:hover {
            border: 1px solid ${crystal500};
        }
    }

    &.blank {
        background: ${scarpaGray50};
        color: ${scarpaGray800};
        border: 1px solid ${scarpaGray25};
        &:hover {
            border: 1px solid ${scarpaGray100};
        }
    }
`;

export const DropdownWrapper = styled.div`
    position: relative;

    .dropdown {
        z-index: 8;
        box-shadow: 0px 0px 1px hsla(219.99999999999997, 3.030303030303034%, 19.411764705882355%, 0.05), 0px 16px 24px rgba(48, 49, 51, 0.1);
        background-color: ${scarpaGray25};
        position: absolute;
        display: flex;
        flex-direction: column;
        border: 1px solid ${scarpaGray100};
        border-radius: 4px;
        color: ${scarpaGray800};
        left: auto;
        right: 100%;
        width: 100%;
        min-width: 180px;
        top: 30px;

        @media ${({ theme }) => theme.screenSizes.tablet} {
            width: 163px;
        }

        @media ${({ theme }) => theme.screenSizes.laptop} {
            width: 100%;
            min-width: 180px;
        }
    }

    .dropdown-subtitle {
        position: relative;
        padding: 12px 16px;
        text-align: right;
        color: ${scarpaGray400};
        font-family: ${robotoRegular};

        @media ${({ theme }) => theme.screenSizes.tablet} {
            padding: 12px 8px;
        }

        @media ${({ theme }) => theme.screenSizes.laptop} {
            text-align: left;
            padding: 8px;
            font-size: 12px;
        }
    }

    .dropdown-item {
        box-sizing: border-box;
        padding: 12px 16px;
        text-align: left;
        font-family: ${robotoRegular};
        cursor: pointer;
        color: ${scarpaGray800};
        display: flex;
        transition: all 0.1s ease-in-out;

        @media ${({ theme }) => theme.screenSizes.tablet} {
            justify-content: end;
        }

        @media ${({ theme }) => theme.screenSizes.laptop} {
            justify-content: start;
        }

        &:hover {
            color: ${spanishViridian500};
            border-left: 2px solid ${spanishViridian500};
            background-color: ${spanishViridian25};
            path {
                fill: ${spanishViridian500};
            }
        }
    }
`;

export const ButtonClose = styled.div`
    position: relative;
    padding: 2px 2px 2px 6px;
    cursor: pointer;
`;
